import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, useNavigate } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import ShowError from "../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';
import { Checkbox } from 'primereact/checkbox';
import Laoding from '../shared/Laoding';
import { fireEvent } from '@testing-library/dom';


export default function Downloads(props) {
    const [loading, setLoading] = useState(true);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [downloads, setDownloads] = useState([
        {btnText:"دانلود", url:"https://Haanaa.ir/Asset/Commons/Downloads/Hana100130_14050201_192809.zip", downloadFileName:"Hana100130_14050201_192809.zip", caption:"دیتابیس آموزش حسابداری"},
        {btnText:"دانلود", url:"https://dl2.soft98.ir/programing/Microsoft.SQL.Server.2022.Enterprise.x64.rar?1687936854", downloadFileName:"Microsoft.SQL.Server.2022.Enterprise.x64.rar", caption:"دیتابیس اسکیو ال سرور 2022"},
        {btnText:"دانلود", url:"https://edge01.82.ir.cdn.ir/programing/SQL.Server.Management.Studio.22.3.2.x64.rar?1773235627", downloadFileName:"SQL.Server.Management.Studio.22.3.2.x64.rar", caption:"مدیریت دیتابیس اسکیو ال سرور"},
        {btnText:"دانلود", url:"https://Haanaa.ir/Asset/Commons/Downloads/SQLEXPR_x64_ENU.rar", downloadFileName:"SQLEXPR_x64_ENU.rar", caption:"اسکیوال اکسپرس"},
        {btnText:"دانلود", url:"https://dorsandesk.ir/dorsandesk-download/", downloadFileName:"", caption:"ریموت دسکتاپ ایرانی درسان دسک"},
        {btnText:"دانلود", url:"https://Haanaa.ir/Asset/Commons/Downloads/vfpoledb.exe", downloadFileName:"vfpoledb.exe", caption:"نصب درایور فاکس پرو، مورد نیاز برای تولید فایل بیمه"},
    ]);
    useEffect(() => {
        var params = {param1:"", param2:"", param3:"", param4:"", param5:""};
        var url = config.Server+`/basic/downloads/list/get`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){                
                response = response.data;
                var ds = response;
                for(var i=0;i<ds.length;i++){
                    ds[i]["btnText"] = "دانلود";
                }
                for(var i=0;i<downloads.length;i++){
                    ds.push({...downloads[i]});
                }
                setDownloads(ds);
                setLoading(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setLoading(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setLoading(false);
        });
    }, []);

    return(
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px"}}>
                <Col className="d-flex justify-content-center align-items-center" style={{}}>
                    <Col md={6} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px"}}>
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto", borderCollapse:"collapse"}}>
                            <tbody>
                                <tr>
                                    <td style={{width:"100%", textAlign:"center"}} colSpan={2}>
                                        <img src={require('../lib/images/hana.webp')} style={{width:"64px"}} />
                                        {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.5em", textAlign:"center"}} colSpan={2}>لیست دانلودها</td>
                                </tr>
                                <tr><td colSpan={2}>&nbsp;</td></tr>
                                {
                                    downloads.map((file, uInd)=>{
                                        return(
                                <tr style={{backgroundColor:(uInd%2==1?"#eee":"#fff")}}>
                                    <td style={{fontSize:"1.1em", textAlign:"center", direction:"rtl", borderTop:"1px dashed #b0b0b0", borderBottom:"1px dashed #b0b0b0", padding:"5px", width:"90px"}}>
                                    {
                                        file.downloadFileName == ""?
                                        <a 
                                            href={file.url} 
                                            target="_blank"
                                            style={{
                                            display: 'inline-block',
                                            padding: '10px 20px',
                                            backgroundColor: '#007bff',
                                            color: 'white',
                                            textDecoration: 'none',
                                            borderRadius: '5px'
                                            }}
                                        >
                                            {file.btnText}
                                        </a>
                                        :
                                        <a 
                                            href={file.url} 
                                            download={file.downloadFileName}
                                            style={{
                                            display: 'inline-block',
                                            padding: '10px 20px',
                                            backgroundColor: '#007bff',
                                            color: 'white',
                                            textDecoration: 'none',
                                            borderRadius: '5px'
                                            }}
                                        >
                                            {file.btnText}
                                        </a>
                                    }
                                    </td>
                                    <td style={{fontSize:"1.1em", textAlign:"right", direction:"rtl", borderTop:"1px dashed #b0b0b0", borderBottom:"1px dashed #b0b0b0", padding:"5px"}}>
                                        {file.caption}
                                    </td>
                                </tr>
                                        )
                                    })
                                }
                                <tr><td colSpan={2}>&nbsp;</td></tr>

                            </tbody>
                        </table>
                    </Col>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}